import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RecaptchaService, isRecaptchaBadgeRoute } from '@core/services/recaptcha.service';
import { filter } from 'rxjs';

@Component({
  selector: 'rec-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'recruiter';
  private readonly router = inject(Router);
  private readonly recaptcha = inject(RecaptchaService);

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.toggleRecaptchaBadge(event.urlAfterRedirects));
  }

  /** Show Google's reCAPTCHA badge only on inicio/login/registro and the public offer page; preload the script there. */
  private toggleRecaptchaBadge(url: string): void {
    const show = isRecaptchaBadgeRoute(url);
    if (show) {
      this.recaptcha.preload();
    }
    document.body.classList.toggle('show-recaptcha-badge', show);
  }
}
